/* eslint-disable react/no-direct-mutation-state */

import React from "react";
import { connect } from "react-redux";
import SoundfontProvider from "../../SoundfontProvider";
import _ from "lodash";
// import { lostWoods } from "./songs";
import "../../styles/index.css";
import "../../styles/piano.css";
import { Piano } from "../../ImportPiano";
import SettingsPopup from "./settingsModal";
import PopupTones from "./popupTones";
import PopupMusicTheory from "./popupMusicTheory";
import SongsWindow from "./songsWindow";
import LabelsModal from "./labelsModal";
import withSnackbarWrapper from "./withSnackbarWrapper";
import Loader from "./loader";

import {
  TONES,
  sevenToneScale,
  eightToneScale,
  sixToneScale,
  fiveToneScale,
  otherToneScales,
  putLabelsOnPiano,
  NOTES,
  changeLabels,
} from "../../helpers/pianoHelpers";
import {
  sevenToneScaleChange,
  eightToneScaleChange,
  sixToneScaleChange,
} from "../../helpers/scaleEditHelper";
import {
  setBaseNote,
  setCurrentSectionName,
  setCurrentSongIndex,
  setDefaultMt,
  setGhostTonesMT,
  setMusicTheoryMidiNums,
  setMusicThoeryFormula,
  setNewSectionModal,
  setPianoLabels,
  setScaleEditing,
  setShowGhost,
  setSongsArray,
  setTonesMT,
  setBufferLoading,
} from "../../store/actions";
import Tuner from "./tuner";
import Draggable from "react-draggable";

class HomePiano extends React.Component {
  state = {
    showSettingsModal: false,
    toggleVocalModal: false,
    toggleMusicTheoryModal: false,
    enableMusicTheory: true,
    toggleLabelsModal: false,
    shiftPressed: false,
    controlPressed: false,
    heading: "",
    TONES: TONES,
    sevenToneScale: sevenToneScale,
    eightToneScale: eightToneScale,
    sixToneScale: sixToneScale,
    fiveToneScale: fiveToneScale,
    otherToneScales: otherToneScales,
    tones: {},
    width: 200,
    height: 200,
    modeNames: [
      "fiveToneScale",
      "sixToneScale",
      "sevenToneScale",
      "eightToneScale",
      "otherToneScales",
    ],
    sevenToneHeading: "",
    chromaticFormula: {
      baseNote: 3,
      tones: 0,
      modesOfScales: 0,
      modesOfScalesValues: { ...otherToneScales[1] },
    },
    chromaticKey: false,
    centerLock: false,
    centerSelect: false,
    centerDegree: NOTES[0],
    prevDegree: "",
    scale: 0.65, // Default scale
    isResizing: false, // Track if resizing
    initialMouseX: 0,
    initialScale: 1,
    scaleIntegerKey: "",
    baseNoteKeys: [
      "H",
      "U",
      "J",
      "A",
      "W",
      "S",
      "E",
      "D",
      "F",
      "T",
      "G",
      "Y",
      "K",
    ],
    ghostArray: [],
  };
  keypress = (e) => {
    this.handleKeyPress(e);
  };
  keyUp = (e) => {
    this.handleKeyUp(e);
  };
  componentDidMount() {
    this.dropdownRef = React.createRef();
    document.addEventListener("click", this.handleOutsideClick);
    window.addEventListener("keydown", this.keypress);
    window.addEventListener("keyup", this.keyUp);
    const array = JSON.parse(localStorage.getItem("songsArray"));
    this.props.setSongsArray(array);
    // this.props.setTonesMT({
    //   baseNote: 3,
    //   tones: 2,
    //   modesOfScales: 0,
    //   modesOfScalesValues: {
    //     x: 0,
    //     y: 0,
    //     prevDegree: "1.",
    //     name: "ionian",
    //     nameColor: "#FF0000",
    //     formulae: [1, 3, 5, 6, 8, 10, 12],
    //     formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
    //     numbers: ["1", "2", "3", "4", "5", "6", "7"],
    //     underlinedNumbers: ["4", "7"],
    //     // doubleUnderlineNumbers: ["2", "3"],
    //   },
    // });
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.keypress);
    document.removeEventListener("click", this.handleOutsideClick);
  }
  componentDidUpdate(prevProps, prevStates) {
    if (
      this.props.openNewSongModal &&
      this.props.openNewSongModal !== prevProps.openNewSongModal
    ) {
      window.removeEventListener("keydown", this.keypress);
    }
    if (
      this.props.openNewSectionModal &&
      this.props.openNewSectionModal !== prevProps.openNewSectionModal
    ) {
      window.removeEventListener("keydown", this.keypress);
    }
    if (
      this.props.ghostTonesMT !== prevProps.ghostTonesMT &&
      this.props.ghostTonesMT !== ""
    ) {
      this.mtChange();
    }
    if (
      (!this.state.enableMusicTheory &&
        this.state.enableMusicTheory !== prevProps.enableMusicTheory) ||
      !this.props.tonesMT
    ) {
      this.removeMusicTheory();
    }
    if (
      this.state.centerLock &&
      this.state.centerLock !== prevStates.centerLock
    ) {
      this.calculateDegree();
    }
    if (
      !this.props.openNewSongModal &&
      this.props.openNewSongModal !== prevProps.openNewSongModal
    ) {
      window.addEventListener("keydown", this.keypress);
    }
    if (
      !this.props.openNewSectionModal &&
      this.props.openNewSectionModal !== prevProps.openNewSectionModal
    ) {
      window.addEventListener("keydown", this.keypress);
    }
    if (this.props.showGhost !== prevProps.showGhost) {
      this.showGhostFunction();
    }
    if (this.state.chromaticKey !== prevStates.chromaticKey) {
      this.mtChange();
    }

    // Perform a deep comparison for complex data structures
    if (
      !_.isEqual(this.props.tonesMT, prevProps.tonesMT) &&
      this.props.tonesMT
    ) {
      this.mtChange();
    }
  }
  handleKeyUp = (e) => {
    if (e.key === "Shift") {
      this.setState({ shiftPressed: false });
    }
    // if (["1", "2", "3", "4", "5", "6", "7"].includes(e.key)) {
    //   this.setState({ scaleIntegerKey: "" });
    //   console.log("Integer key released, resetting state.");
    // }
  };

  handleOutsideClick = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ centerSelect: false }); // Close the dropdown
    }
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      centerSelect: !prevState.centerSelect,
    }));
  };

  handleSelect = (item, index) => {
    this.setState(
      {
        centerDegree: item,
        centerSelect: false, // Close the dropdown after selection
      },
      () => {
        if (this.state.centerLock) {
          this.calculateDegree(); // Call calculateDegree if centerLock is true
        } else {
          let previousMT = { ...this.props.tonesMT };
          previousMT.baseNote = index;
          this.props.setTonesMT(previousMT);
        }
      }
    );
  };

  movePianoLeft = () => {
    let scroll = document.getElementsByClassName("piano-wrapper")[0].scrollLeft;
    if (scroll >= 0)
      document.getElementsByClassName("piano-wrapper")[0].scrollLeft =
        scroll - 50;
  };
  movePianoRight = () => {
    let scroll = document.getElementsByClassName("piano-wrapper")[0].scrollLeft;
    document.getElementsByClassName("piano-wrapper")[0].scrollLeft =
      scroll + 50;
  };
  toggleSettingsModal = () => {
    let showSettingsModal = !this.state.showSettingsModal;
    this.setState({ showSettingsModal });
  };
  toggleVocalModalFunc = () => {
    let toggleVocalModal = !this.state.toggleVocalModal;
    this.setState({ toggleVocalModal, showSettingsModal: false });
  };
  toggleMusicTheoryModalFunc = () => {
    let toggleMusicTheoryModal = !this.state.toggleMusicTheoryModal;
    this.setState({ toggleMusicTheoryModal, showSettingsModal: false });
  };
  toggleLabelsModalFunc = () => {
    let toggleLabelsModal = !this.state.toggleLabelsModal;
    this.setState({ toggleLabelsModal, showSettingsModal: false });
  };
  setEnableMusicTheory = (data) => {
    this.setState({ enableMusicTheory: data });
  };
  handleOpenSongWindow = () => {
    document.querySelector(".menu").style.right = "0";
    document.querySelector(".container-wrapper").style.marginRight = "321px";
  };
  handleCenterLock = () => {
    if (this.state.enableMusicTheory) {
      let centerLock = !this.state.centerLock;
      this.setState({ centerLock });
    }
  };
   setMusicTheoryOnPiano = (data) => {
    if (data) {
      this.props.setTonesMT(data);
      this.props.setDefaultMt(data);
      this.setState(
        {
          showMusicTheoryModal: false,
          chromaticFormula: {
            ...this.state.chromaticFormula,
            baseNote: data.baseNote,
          },
        },
        () => {
          this.mtChange();
        }
      );
    } else {
      this.setState({
        showMusicTheoryModal: false,
      });
    }
    
    this.props.setMusicThoeryFormula(
      this.props.NOTES[this.props.tonesMT.baseNote] +
        this.state[this.state.modeNames[data.tones]][
          this.props.tonesMT.modesOfScales
        ].name +
        this.state.TONES[this.props.tonesMT.tones]
    );
  };
  handleKeyPress = (event) => {
    event.preventDefault();
    let activeFormula = document.querySelector(".formula-container-hover");
    activeFormula?.classList.remove("formula-container-hover");
    if (event.key == "Control") {
      this.setState({ controlPressed: true });
    }
    if (this.state.controlPressed) {
      if (event.key == "z") {
        this.props.setTonesMT(this.props.defaultMt);
      }
    }
    if (
      event.key !== "Shift" &&
      event.key !== "ArrowUp" &&
      event.key !== "ArrowDown"
    ) {
      // remove and reset ghost when key is pressed
      this.props.setShowGhost(false);
    }

    if (event.key == "Escape") {
      document.querySelectorAll(".react-piano-music-dots").forEach((dot) => {
        dot.classList.remove("edit-key-highlight");
      });
      this.setState({ scaleIntegerKey: "" });
    }

    console.log(event.key);
    // Check if a number key (1-8) is pressed and if no integer key is currently stored
    if (["1", "2", "3", "4", "5", "6", "7", "8"].includes(event.key)) {
      this.setState({ scaleIntegerKey: event.key });

      document.querySelectorAll(".react-piano-music-dots").forEach((dot) => {
        dot.classList.remove(
          "edit-key-highlight",
          "edit-key-highlight-fade-black",
          "edit-key-highlight-fade-red"
        );

        let innerElement = dot.querySelector(".number");

        if (innerElement && innerElement.innerText.includes(event.key)) {
          if (!dot.classList.contains("white")) {
            dot.classList.add("edit-key-highlight");
          }
        }
      });

      console.log("key integer", event.key);
    }

    // Handle arrow keys
    if (
      this.state.scaleIntegerKey &&
      (event.key === "ArrowUp" || event.key === "ArrowDown")
    ) {
      const { name, degree, secondDegree, name2 } =
        this.props.tonesMT.modesOfScalesValues;
      const formula = name2
        ? `${name || ""} ${name2 || ""} ${degree || ""} ${
            secondDegree || ""
          }`.trim()
        : `${name || ""} ${degree || ""} ${secondDegree || ""}`.trim();

      let editFormula;
      if (this.props.tonesMT.tones === 2) {
        editFormula = {
          ...sevenToneScaleChange[formula]?.[this.state.scaleIntegerKey]?.[
            event.key
          ],
        };
      } else if (this.props.tonesMT.tones === 1) {
        editFormula = {
          ...sixToneScaleChange[formula]?.[this.state.scaleIntegerKey]?.[
            event.key
          ],
        };
      } else if (this.props.tonesMT.tones === 3) {
        editFormula = {
          ...eightToneScaleChange[formula]?.[this.state.scaleIntegerKey]?.[
            event.key
          ],
        };
      }
      console.log("edited formula...", editFormula);
      if (!editFormula.name) {
        this.props.useSnackbarCustom.enqueueSnackbar("Invalid Mode!", {
          variant: "warning",
        });
        return;
      }
      let newTone;
      if (editFormula.numbers.length === 6) {
        newTone = 1;
      } else if (editFormula.numbers.length === 7) {
        newTone = 2;
      } else {
        newTone = 3;
      }
      let baseNote = this.props.tonesMT.baseNote;
      if (this.state.scaleIntegerKey === "1" && !editFormula.chromaticFormula) {
        if (event.key === "ArrowUp") {
          baseNote = baseNote + 1;
          if (baseNote === 12) {
            baseNote = 0;
          }
        } else {
          baseNote = baseNote - 1;
          if (baseNote === -1) {
            baseNote = 11;
          }
        }
      }
      if (
        formula === "locrian ♮6" &&
        this.state.scaleIntegerKey === 3 &&
        event.key === "ArrowDown"
      ) {
        baseNote = baseNote + 1;
        if (baseNote === 12) {
          baseNote = 0;
        }
      }
      if (
        formula === "locrian b4 bb7" &&
        this.state.scaleIntegerKey === 2 &&
        event.key === "ArrowDown"
      ) {
        baseNote = baseNote - 1;
        if (baseNote === -1) {
          baseNote = 11;
        }
      }
      if (
        formula === "lydian b3" &&
        this.state.scaleIntegerKey === 6 &&
        event.key === "ArrowUp"
      ) {
        baseNote = baseNote - 1;
        if (baseNote === -1) {
          baseNote = 11;
        }
      }
      if (
        formula === "ionian b3" &&
        this.state.scaleIntegerKey === 2 &&
        event.key === "ArrowDown"
      ) {
        baseNote = baseNote + 1;
        if (baseNote === 12) {
          baseNote = 0;
        }
      }
      if (
        formula === "dorian b2" &&
        this.state.scaleIntegerKey === 7 &&
        event.key === "ArrowUp"
      ) {
        baseNote = baseNote - 1;
        if (baseNote === -1) {
          baseNote = 11;
        }
      }
      if (
        formula === "Half/whole" &&
        this.state.scaleIntegerKey === 8 &&
        event.key === "ArrowUp"
      ) {
        baseNote = baseNote - 1;
        if (baseNote === -1) {
          baseNote = 11;
        }
      }
      if (
        formula === "Whole/half" &&
        this.state.scaleIntegerKey === 2 &&
        event.key === "ArrowDown"
      ) {
        baseNote = baseNote + 1;
        if (baseNote === 12) {
          baseNote = 0;
        }
      }
      this.props.setTonesMT({
        ...this.props.tonesMT,
        baseNote,
        tones: newTone,
        modesOfScalesValues: editFormula,
      });
    }
    if (event.key === "Enter") {
      const {
        songsArray,
        currentSongName,
        currentSectionName,
        tonesMT,
        currentSongIndex,
      } = this.props;

      // Check if a song is active
      if (!currentSongName) {
        alert("Please select a song.");
        return;
      }

      // Determine the section to add the formula
      let targetSectionName = currentSectionName;

      // If no section is selected, default to the first section of the active song
      if (!targetSectionName) {
        const songSections = Object.keys(songsArray[currentSongName]);
        if (songSections.length === 0) {
          alert("The selected song has no sections.");
          return;
        }
        targetSectionName = songSections[0]; // Use the first section
      }

      // Retrieve the target section's array or default to an empty array
      const updatedSectionArray = [
        ...(songsArray[currentSongName][targetSectionName] || []),
      ];
      const updatedTonesMT = { ...tonesMT, note: NOTES[tonesMT.baseNote] };
      // Add the formula at the appropriate position
      if (currentSongIndex !== undefined && currentSongIndex !== null) {
        // Insert after the currently selected formula
        updatedSectionArray.splice(currentSongIndex + 1, 0, updatedTonesMT);
      } else {
        // If no formula is selected, add it to the end of the section
        updatedSectionArray.push(updatedTonesMT);
      }

      // Create the updated songs array
      const updatedSongsArray = {
        ...songsArray,
        [currentSongName]: {
          ...songsArray[currentSongName],
          [targetSectionName]: updatedSectionArray,
        },
      };

      // Update the songs array in your state or Redux
      this.props.setSongsArray(updatedSongsArray);
      this.props.setCurrentSongIndex(this.props.currentSongIndex + 1);
    }

    if (this.state.enableMusicTheory) {
      console.log("music theory enabled!");
      // ----------------------------------------------- ARROW LEFT CONDITIONS START ------------------------------------------------------
      if (event.key === "ArrowLeft") {
        // let obj1 = { ...this.props.tonesMT };
        let prevTonesMT = { ...this.props.tonesMT };
        if (this.props.tonesMT.tones === 0) {
          // Pentatonic
          if (this.state.shiftPressed) {
            // scale change
            // no formulae so nothing happens
          }
          if (this.props.NOTES[this.props.tonesMT.baseNote - 1]) {
            prevTonesMT.baseNote = this.props.tonesMT.baseNote - 1;
            this.props.setTonesMT(prevTonesMT);
          } else {
            prevTonesMT.baseNote = this.props.NOTES.length - 1;
            this.props.setTonesMT(prevTonesMT);
          }
        } else if (this.props.tonesMT.tones === 1) {
          // Hexaphonic
          if (this.state.shiftPressed) {
            // scale change
            if (this.props.tonesMT.modesOfScalesValues.y != 2) {
              if (this.props.tonesMT.modesOfScalesValues.y === 0) {
                // now change state
                let obj;
                let idx;
                sixToneScale.map((item, index) => {
                  if (
                    item.x === this.props.tonesMT.modesOfScalesValues.x &&
                    item.y === 1
                  ) {
                    obj = item;
                    idx = index;
                  }
                });
                prevTonesMT.modesOfScalesValues = obj;
                prevTonesMT.modesOfScales = idx;
              } else {
                let obj;
                let idx;
                sixToneScale.map((item, index) => {
                  if (
                    item.x === this.props.tonesMT.modesOfScalesValues.x &&
                    item.y === this.props.tonesMT.modesOfScalesValues.y - 1
                  ) {
                    obj = item;
                    idx = index;
                  }
                });
                prevTonesMT.modesOfScalesValues = obj;
                prevTonesMT.modesOfScales = idx;
              }
            }
          }
          if (this.state.shiftPressed) {
            let minuIndx = prevTonesMT.modesOfScalesValues.formulae[1] - 1;
            let baseValue = this.props.tonesMT.baseNote;
            for (let i = 0; i < minuIndx; i++) {
              if (this.props.NOTES[baseValue - 1]) {
                baseValue = baseValue - 1;
                prevTonesMT.baseNote = baseValue;
              } else {
                baseValue = this.props.NOTES.length - 1;
                prevTonesMT.baseNote = baseValue;
              }
            }
            this.props.setTonesMT(prevTonesMT);
          } else {
            if (this.props.NOTES[this.props.tonesMT.baseNote - 1]) {
              prevTonesMT.baseNote = this.props.tonesMT.baseNote - 1;
              this.props.setTonesMT(prevTonesMT);
            } else {
              prevTonesMT.baseNote = this.props.NOTES.length - 1;
              this.props.setTonesMT(prevTonesMT);
            }
          }
        } else if (this.props.tonesMT.tones === 2) {
          // Seven tone scales
          if (this.state.shiftPressed) {
            // scale change
            if (this.props.tonesMT.modesOfScalesValues.x === 0) {
              // now change state
              let obj;
              let idx;
              sevenToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === 6
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
            } else {
              let obj;
              let idx;
              sevenToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === this.props.tonesMT.modesOfScalesValues.x - 1
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
            }
          }
          if (this.state.shiftPressed) {
            let minuIndx = prevTonesMT.modesOfScalesValues.formulae[1] - 1;
            console.log(minuIndx);
            let baseValue = this.props.tonesMT.baseNote;
            console.log(baseValue);
            for (let i = 0; i < minuIndx; i++) {
              if (this.props.NOTES[baseValue - 1]) {
                baseValue = baseValue - 1;
                prevTonesMT.baseNote = baseValue;
              } else {
                baseValue = this.props.NOTES.length - 1;
                prevTonesMT.baseNote = baseValue;
              }
            }
            this.props.setTonesMT(prevTonesMT);
          } else {
            if (this.props.NOTES[this.props.tonesMT.baseNote - 1]) {
              prevTonesMT.baseNote = this.props.tonesMT.baseNote - 1;
              this.props.setTonesMT(prevTonesMT);
            } else {
              prevTonesMT.baseNote = this.props.NOTES.length - 1;
              this.props.setTonesMT(prevTonesMT);
            }
          }
          console.log("note ", prevTonesMT.baseNote);
        } else if (this.props.tonesMT.tones === 3) {
          // Eight Tone Scales
          let shiftFactor = false;
          if (this.state.shiftPressed) {
            // scale change
            if (this.props.tonesMT.modesOfScalesValues.x === 0) {
              // now change state
              let obj;
              let idx;
              eightToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === 1
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
              shiftFactor = true;
            } else {
              let obj;
              let idx;
              eightToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === this.props.tonesMT.modesOfScalesValues.x - 1
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
            }
          }

          if (shiftFactor) {
            // base translations with shift factor
            if (this.props.NOTES[this.props.tonesMT.baseNote - 1]) {
              if (this.props.NOTES[this.props.tonesMT.baseNote - 2]) {
                prevTonesMT.baseNote = this.props.tonesMT.baseNote - 2;
                this.props.setTonesMT(prevTonesMT);
              } else {
                prevTonesMT.baseNote = this.props.NOTES.length - 1;
                this.props.setTonesMT(prevTonesMT);
              }
            } else {
              prevTonesMT.baseNote = this.props.NOTES.length - 2;
              this.props.setTonesMT(prevTonesMT);
            }
          } else {
            // no shifts only normal base translations
            if (this.props.NOTES[this.props.tonesMT.baseNote - 1]) {
              prevTonesMT.baseNote = this.props.tonesMT.baseNote - 1;
              this.props.setTonesMT(prevTonesMT);
            } else {
              prevTonesMT.baseNote = this.props.NOTES.length - 1;
              this.props.setTonesMT(prevTonesMT);
            }
          }
        } else if (this.props.tonesMT.tones === 4) {
          // Other Scales
          if (this.state.shiftPressed) {
            // scale change
            // no formulae so nothing happens
          }
          if (this.props.NOTES[this.props.tonesMT.baseNote - 1]) {
            prevTonesMT.baseNote = this.props.tonesMT.baseNote - 1;
            this.props.setTonesMT(prevTonesMT);
          } else {
            prevTonesMT.baseNote = this.props.NOTES.length - 1;
            this.props.setTonesMT(prevTonesMT);
          }
        }

        this.setState({
          lastKey: "ArrowLeft",
          chromaticFormula: {
            ...this.state.chromaticFormula,
            baseNote: prevTonesMT.baseNote,
          },
        });
      }

      // ----------------------------------------------- ARROW LEFT CONDITIONS END ------------------------------------------------------

      // ----------------------------------------------- ARROW RIGHT CONDITIONS START ------------------------------------------------------
      else if (event.key === "ArrowRight") {
        // let obj1 = { ...this.props.tonesMT };
        let prevTonesMT = { ...this.props.tonesMT };
        if (this.props.tonesMT.tones === 0) {
          // Pentatonic
          if (this.state.shiftPressed) {
            // scale change
            //nothing happens no formulae
          }
          if (this.props.NOTES[this.props.tonesMT.baseNote + 1]) {
            prevTonesMT.baseNote = this.props.tonesMT.baseNote + 1;
            this.props.setTonesMT(prevTonesMT);
          } else {
            prevTonesMT.baseNote = 0;
            this.props.setTonesMT(prevTonesMT);
          }
        } else if (this.props.tonesMT.tones === 1) {
          let minuIndx = prevTonesMT.modesOfScalesValues.formulae[1] - 1;
          // Hexaphonic
          if (this.state.shiftPressed) {
            // scale change
            if (this.props.tonesMT.modesOfScalesValues.y !== 2) {
              if (this.props.tonesMT.modesOfScalesValues.y === 1) {
                // now change state
                let obj;
                let idx;
                sixToneScale.map((item, index) => {
                  if (
                    item.x === this.props.tonesMT.modesOfScalesValues.x &&
                    item.y === 0
                  ) {
                    obj = item;
                    idx = index;
                  }
                });
                prevTonesMT.modesOfScalesValues = obj;
                prevTonesMT.modesOfScales = idx;
              } else {
                let obj;
                let idx;
                sixToneScale.map((item, index) => {
                  if (
                    item.x === this.props.tonesMT.modesOfScalesValues.x &&
                    item.y === this.props.tonesMT.modesOfScalesValues.y + 1
                  ) {
                    obj = item;
                    idx = index;
                  }
                });
                prevTonesMT.modesOfScalesValues = obj;
                prevTonesMT.modesOfScales = idx;
              }
            }
          }
          if (this.state.shiftPressed) {
            let baseValue = this.props.tonesMT.baseNote;
            for (let i = 0; i < minuIndx; i++) {
              if (this.props.NOTES[baseValue + 1]) {
                baseValue = baseValue + 1;
                prevTonesMT.baseNote = baseValue;
              } else {
                baseValue = 0;
                prevTonesMT.baseNote = baseValue;
              }
            }
            this.props.setTonesMT(prevTonesMT);
          } else {
            if (this.props.NOTES[this.props.tonesMT.baseNote + 1]) {
              prevTonesMT.baseNote = this.props.tonesMT.baseNote + 1;
              this.props.setTonesMT(prevTonesMT);
            } else {
              prevTonesMT.baseNote = 0;
              this.props.setTonesMT(prevTonesMT);
            }
          }
        } else if (this.props.tonesMT.tones === 2) {
          let minuIndx = prevTonesMT.modesOfScalesValues.formulae[1] - 1;
          // Seven tone scales
          if (this.state.shiftPressed) {
            // scale change
            if (this.props.tonesMT.modesOfScalesValues.x === 6) {
              // now change state
              let obj;
              let idx;
              sevenToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === 0
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
            } else {
              let obj;
              let idx;
              sevenToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === this.props.tonesMT.modesOfScalesValues.x + 1
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
            }
          }
          if (this.state.shiftPressed) {
            let baseValue = this.props.tonesMT.baseNote;
            for (let i = 0; i < minuIndx; i++) {
              if (this.props.NOTES[baseValue + 1]) {
                baseValue = baseValue + 1;
                prevTonesMT.baseNote = baseValue;
              } else {
                baseValue = 0;
                prevTonesMT.baseNote = baseValue;
              }
            }
            this.props.setTonesMT(prevTonesMT);
          } else {
            if (this.props.NOTES[this.props.tonesMT.baseNote + 1]) {
              prevTonesMT.baseNote = this.props.tonesMT.baseNote + 1;
              this.props.setTonesMT(prevTonesMT);
            } else {
              prevTonesMT.baseNote = 0;
              this.props.setTonesMT(prevTonesMT);
            }
          }
        } else if (this.props.tonesMT.tones === 3) {
          // Eight Tone Scales
          let shiftFactor = false;
          if (this.state.shiftPressed) {
            // scale change
            if (this.props.tonesMT.modesOfScalesValues.x === 1) {
              // now change state
              let obj;
              let idx;
              eightToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === 0
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
              shiftFactor = true;
            } else {
              let obj;
              let idx;
              eightToneScale.map((item, index) => {
                if (
                  item.y === this.props.tonesMT.modesOfScalesValues.y &&
                  item.x === this.props.tonesMT.modesOfScalesValues.x + 1
                ) {
                  obj = item;
                  idx = index;
                }
              });
              prevTonesMT.modesOfScalesValues = obj;
              prevTonesMT.modesOfScales = idx;
            }
          }
          if (shiftFactor) {
            // base translations with shift factor
            if (this.props.NOTES[this.props.tonesMT.baseNote + 1]) {
              if (this.props.NOTES[this.props.tonesMT.baseNote + 2]) {
                prevTonesMT.baseNote = this.props.tonesMT.baseNote + 2;
                this.props.setTonesMT(prevTonesMT);
              } else {
                prevTonesMT.baseNote = 0;
                this.props.setTonesMT(prevTonesMT);
              }
            } else {
              prevTonesMT.baseNote = 1;
              this.props.setTonesMT(prevTonesMT);
            }
          } else {
            if (this.props.NOTES[this.props.tonesMT.baseNote + 1]) {
              prevTonesMT.baseNote = this.props.tonesMT.baseNote + 1;
              this.props.setTonesMT(prevTonesMT);
            } else {
              prevTonesMT.baseNote = 0;
              this.props.setTonesMT(prevTonesMT);
            }
          }
        } else if (this.props.tonesMT.tones === 4) {
          // Other Scales
          if (this.state.shiftPressed) {
            // scale change
            //nothing happens no formulae
          }
          if (this.props.NOTES[this.props.tonesMT.baseNote + 1]) {
            prevTonesMT.baseNote = this.props.tonesMT.baseNote + 1;
            this.props.setTonesMT(prevTonesMT);
          } else {
            prevTonesMT.baseNote = 0;
            this.props.setTonesMT(prevTonesMT);
          }
        }

        this.setState({
          lastKey: "ArrowRight",
          chromaticFormula: {
            ...this.state.chromaticFormula,
            baseNote: prevTonesMT.baseNote,
          },
        });
      }

      // ----------------------------------------------- ARROW RIGHT CONDITIONS END ------------------------------------------------------
      else if (event.key === "Shift") {
        // console.log("SHIFT pressed ==> ", event.key);
        this.setState({ shiftPressed: true });
      } else if (event.key === "0") {
        console.log("Key  pressed", event.key);
        if (this.state.enableMusicTheory) {
          let prevTonesMT = { ...this.props.tonesMT };
          prevTonesMT.modesOfScalesValues.chromaticFormula
            ? (prevTonesMT.modesOfScalesValues.chromaticFormula = false)
            : (prevTonesMT.modesOfScalesValues.chromaticFormula = true);
          this.props.setTonesMT(prevTonesMT);
        }
        this.setState((prevState) => ({
          chromaticKey: !prevState.chromaticKey,
        }));
      }
      if (this.state.shiftPressed) {
        // Check if tones equals 2, you can adjust this condition as needed
        if (this.props.tonesMT.tones === 2) {
          // Use event.code to ensure we are capturing number keys 1 to 7
          const numberKeyCodes = [
            "Digit1",
            "Digit2",
            "Digit3",
            "Digit4",
            "Digit5",
            "Digit6",
            "Digit7",
          ];
          let prevTonesMT = { ...this.props.tonesMT };
          // Check if the key pressed is one of the number keys between 1 to 7
          if (numberKeyCodes.includes(event.code)) {
            // Convert the key pressed to the corresponding number
            const pressedNumber = parseInt(event.code.replace("Digit", ""), 10);

            // Only process numbers greater than 0 and less than or equal to 7
            if (pressedNumber >= 1 && pressedNumber <= 7) {
              // Now find the jumped formula based on y and x
              let jumpedFormula = sevenToneScale.find(
                (formula) =>
                  formula.y === this.props.tonesMT.modesOfScalesValues.y &&
                  formula.x === pressedNumber - 1 // Subtract 1 to match index
              );

              let baseValue, minuIndx;
              for (let i = 0; i < 7; i++) {
                minuIndx = prevTonesMT.modesOfScalesValues.formulae[1] - 1;
                baseValue = prevTonesMT.baseNote;
                if (prevTonesMT.modesOfScalesValues.x === 6) {
                  // now change state
                  let obj;
                  let idx;
                  sevenToneScale.map((item, index) => {
                    if (
                      item.y === prevTonesMT.modesOfScalesValues.y &&
                      item.x === 0
                    ) {
                      obj = item;
                      idx = index;
                    }
                  });
                  if (obj) {
                    for (let i = 0; i < minuIndx; i++) {
                      if (this.props.NOTES[baseValue + 1]) {
                        baseValue = baseValue + 1;
                        prevTonesMT.baseNote = baseValue;
                      } else {
                        baseValue = 0;
                        prevTonesMT.baseNote = 0;
                      }
                    }

                    prevTonesMT.modesOfScalesValues = obj;
                    prevTonesMT.modesOfScales = idx;
                    if (obj.x === jumpedFormula.x) break;
                  }
                } else {
                  let obj;
                  let idx;
                  sevenToneScale.map((item, index) => {
                    if (
                      item.y === prevTonesMT.modesOfScalesValues.y &&
                      item.x === prevTonesMT.modesOfScalesValues.x + 1
                    ) {
                      obj = item;
                      idx = index;
                    }
                  });
                  if (obj) {
                    for (let i = 0; i < minuIndx; i++) {
                      if (this.props.NOTES[baseValue + 1]) {
                        baseValue = baseValue + 1;
                        prevTonesMT.baseNote = baseValue;
                      } else {
                        baseValue = 0;
                        prevTonesMT.baseNote = 0;
                      }
                    }

                    prevTonesMT.modesOfScalesValues = obj;
                    prevTonesMT.modesOfScales = idx;
                    if (obj.x === jumpedFormula.x) break;
                  }
                }
              }
              prevTonesMT.modesOfScalesValues = { ...jumpedFormula };
              this.props.setTonesMT(prevTonesMT);
            }
          }
        }
        if (event.key === "ArrowUp") {
          let index = this.props.currentSongIndex - 1;

          if (index < 0) {
            // Move to the previous section if available
            const sections = Object.keys(
              this.props.songsArray[this.props.currentSongName]
            );
            const currentSectionIndex = sections.indexOf(
              this.props.currentSectionName
            );

            // Find the previous non-empty section
            for (let i = currentSectionIndex - 1; i >= 0; i--) {
              const previousSectionName = sections[i];
              const previousSection =
                this.props.songsArray[this.props.currentSongName][
                  previousSectionName
                ];

              if (previousSectionName === "artist") {
                this.props.useSnackbarCustom.enqueueSnackbar(
                  "No previous Scales",
                  {
                    variant: "warning",
                  }
                );
                return;
              }

              if (previousSection && previousSection.length > 0) {
                const previousSectionLastIndex = previousSection.length - 1;
                this.props.setTonesMT(
                  previousSection[previousSectionLastIndex]
                );
                this.props.setDefaultMt(
                  previousSection[previousSectionLastIndex]
                );
                this.props.setGhostTonesMT(previousSection[0]);
                this.props.setCurrentSectionName(previousSectionName);
                this.props.setCurrentSongIndex(previousSectionLastIndex);
                return;
              }
            }

            // If no valid previous section found
            this.props.useSnackbarCustom.enqueueSnackbar("No previous Scales", {
              variant: "warning",
            });
          } else {
            // Stay within the current section
            this.props.setTonesMT(
              this.props.songsArray[this.props.currentSongName][
                this.props.currentSectionName
              ][index]
            );
            this.props.setDefaultMt(
              this.props.songsArray[this.props.currentSongName][
                this.props.currentSectionName
              ][index]
            );
            this.props.setGhostTonesMT(
              this.props.songsArray[this.props.currentSongName][
                this.props.currentSectionName
              ][index + 1]
            );
            this.props.setCurrentSongIndex(index);
          }
        }

        if (event.key === "ArrowDown") {
          let index = this.props.currentSongIndex + 1;

          if (
            index >
            this.props.songsArray[this.props.currentSongName][
              this.props.currentSectionName
            ].length -
              1
          ) {
            // Move to the next section if available
            const sections = Object.keys(
              this.props.songsArray[this.props.currentSongName]
            );
            const currentSectionIndex = sections.indexOf(
              this.props.currentSectionName
            );

            // Find the next non-empty section
            for (let i = currentSectionIndex + 1; i < sections.length; i++) {
              const nextSectionName = sections[i];
              const nextSection =
                this.props.songsArray[this.props.currentSongName][
                  nextSectionName
                ];

              if (nextSection && nextSection.length > 0) {
                this.props.setTonesMT(nextSection[0]);
                this.props.setDefaultMt(nextSection[0]);
                this.props.setGhostTonesMT(nextSection[1] || nextSection[0]);
                this.props.setCurrentSectionName(nextSectionName);
                this.props.setCurrentSongIndex(0);
                return;
              }
            }

            // If no valid next section found
            this.props.useSnackbarCustom.enqueueSnackbar("No more Scales", {
              variant: "warning",
            });
          } else {
            // Stay within the current section
            this.props.setTonesMT(
              this.props.songsArray[this.props.currentSongName][
                this.props.currentSectionName
              ][index]
            );
            this.props.setDefaultMt(
              this.props.songsArray[this.props.currentSongName][
                this.props.currentSectionName
              ][index]
            );
            if (
              index ===
              this.props.songsArray[this.props.currentSongName][
                this.props.currentSectionName
              ].length -
                1
            ) {
              this.props.setGhostTonesMT(
                this.props.songsArray[this.props.currentSongName][
                  this.props.currentSectionName
                ][0]
              );
            } else {
              this.props.setGhostTonesMT(
                this.props.songsArray[this.props.currentSongName][
                  this.props.currentSectionName
                ][index + 1]
              );
            }
            this.props.setCurrentSongIndex(index);
          }
        }
      }
    }
    if (this.state.baseNoteKeys.includes(event.key)) {
      if (this.state.shiftPressed) {
        let index = this.state.baseNoteKeys.findIndex((x) => x === event.key);
        let prevTonesMT = { ...this.props.tonesMT };
        prevTonesMT.baseNote = index < 12 ? index : 3;
        this.props.setTonesMT(prevTonesMT);
      }
    }
  };

  sevenToneFormula = () => {
    const mainScales = [
      "Major",
      "Major Harmonic",
      "Minor Harmonic",
      "Minor Melodic",
    ];
    let prev = { ...this.props.tonesMT };
    let baseValue;
    let heading, minuIndx;
    for (let i = 0; i < 7; i++) {
      minuIndx = prev.modesOfScalesValues.formulae[1] - 1;
      baseValue = prev.baseNote;
      if (prev.modesOfScalesValues.x === 6) {
        // now change state
        let obj;
        let idx;
        sevenToneScale.map((item, index) => {
          if (item.y === prev.modesOfScalesValues.y && item.x === 0) {
            obj = item;
            idx = index;
          }
        });
        if (obj) {
          heading = obj.x;
          for (let i = 0; i < minuIndx; i++) {
            if (this.props.NOTES[baseValue + 1]) {
              baseValue = baseValue + 1;
              prev.baseNote = baseValue;
            } else {
              baseValue = 0;
              prev.baseNote = 0;
            }
          }

          prev.modesOfScalesValues = obj;
          prev.modesOfScales = idx;
          if (heading === 0) break;
        }
      } else {
        let obj;
        let idx;
        sevenToneScale.map((item, index) => {
          if (
            item.y === prev.modesOfScalesValues.y &&
            item.x === prev.modesOfScalesValues.x + 1
          ) {
            obj = item;
            idx = index;
          }
        });
        if (obj) {
          heading = obj.x;
          for (let i = 0; i < minuIndx; i++) {
            if (this.props.NOTES[baseValue + 1]) {
              baseValue = baseValue + 1;
              prev.baseNote = baseValue;
            } else {
              baseValue = 0;
              prev.baseNote = 0;
            }
          }

          prev.modesOfScalesValues = obj;
          prev.modesOfScales = idx;
          if (heading === 0) break;
        }
      }
    }
    let rhombusDots = [];
    let j = prev.baseNote;
    for (let i = 0; i < 8; i++) {
      if (i === 0) {
        rhombusDots.push({
          index: j,
        });
      } else {
        j = j + 12;
        rhombusDots.push({
          index: j,
        });
      }
    }
    let sevenScaleNote = this.props.baseNote[prev.baseNote];

    // Check if it's Major Melodic or Major Harmonic
    const isMajorMelodicOrHarmonic =
      mainScales[prev.modesOfScalesValues.y].includes("Major Melodic") ||
      mainScales[prev.modesOfScalesValues.y].includes("Major Harmonic");

    // Handle D♭/C♯ and A♭/G♯ cases
    if (isMajorMelodicOrHarmonic) {
      if (sevenScaleNote === "D♭/C♯") {
        sevenScaleNote = "D♭";
      } else if (sevenScaleNote === "A♭/G♯") {
        sevenScaleNote = "A♭";
      } else {
        sevenScaleNote = sevenScaleNote;
      }
    } else {
      if (sevenScaleNote === "D♭/C♯") {
        sevenScaleNote = "C♯";
      } else if (sevenScaleNote === "A♭/G♯") {
        sevenScaleNote = "G♯";
      } else {
        sevenScaleNote = sevenScaleNote;
      }
    }

    // Update state with sevenToneHeading
    this.setState({
      sevenToneHeading: `${sevenScaleNote} ${
        mainScales[prev.modesOfScalesValues.y]
      }`,
    });

    if (
      this.props.tonesMT.tones === 2 &&
      !(
        this.props.userSelectedLabels && this.props.selectedLabel == "No Labels"
      )
    ) {
      
      putLabelsOnPiano(
        this.props.tonesMT.note,
        this.props.setPianoLabels,
        this.props.tonesMT.tones,
        this.props.tonesMT.modesOfScalesValues.y,
        this.props.setBaseNote
      );
    }
    return rhombusDots;
  };
  removeMusicTheory = () => {
    //remove old dots
    document.querySelectorAll(".react-piano-music-dots").forEach((element) => {
      element.classList.remove("black");
      element.classList.remove("red");
      element.classList.remove("grey");
      element.classList.remove("white");
      element.classList.remove("rhombus");
      element.classList.remove("square");
      element.classList.remove("hide-ghost");
    });
    document.querySelectorAll(".react-piano-music-dots span").forEach((x) => {
      x.classList.remove("double-underline");
      x.classList.remove("single-underline");
    });
    //remove numbers
    document
      .querySelectorAll(".react-piano-music-dots span")
      .forEach((element) => (element.innerHTML = ""));
  };
  // for chromatic formula
  mtChromatic = () => {
    this.removeMusicTheory();
    if (!this.props.tonesMT?.modesOfScalesValues?.chromaticFormula) {
      return;
    }

    let redDots = [];
    let j = this.props.tonesMT.baseNote;
    for (let i = 0; i < 8; i++) {
      if (i === 0) {
        redDots.push({
          index: j,
        });
      } else {
        j = j + 12;
        redDots.push({
          index: j,
        });
      }
    }

    const dotsArray = document.querySelectorAll(".react-piano-music-dots");

    dotsArray.forEach((element, index) => {
      let matchedIndex = redDots.find((x) => x.index === index);
      if (matchedIndex) {
        if (matchedIndex.rhombus) {
          element.classList.add("rhombus");
        }
        element.classList.remove("white");
        element.classList.add("red");
        element.querySelectorAll("span").forEach((elem, index) => {
          elem.innerHTML = "1";
        });
      }
    });

    let blueDots = [];
    for (let i of redDots) {
      if (this.state.chromaticFormula.modesOfScalesValues.formulae) {
        for (let key of this.state.chromaticFormula.modesOfScalesValues
          .formulae) {
          let idx = i.index + key - 1;
          if (idx > 95) {
            // Handle wrapping around the index if it exceeds 95
            const wrappedIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            if (idx >= 96 && idx <= 106) {
              const wrappedIdx = wrappedIndexes[idx - 96];
              blueDots.push({
                index: wrappedIdx,
              });
            }
          } else {
            if (idx !== i.index) {
              blueDots.push({
                index: idx,
              });
            }
          }
        }
      }
    }
    // redDots.sort();
    let numbersOnRed;
    numbersOnRed =
      this.state.chromaticFormula.modesOfScalesValues.numbers.length + 1;
    let indexInner = 2;
    for (let i = 0; i < blueDots.length; i++) {
      blueDots[i].number = indexInner;
      indexInner += 1;
      if (indexInner >= numbersOnRed) {
        indexInner = 2;
      }
    }

    document
      .querySelectorAll(".react-piano-music-dots")
      .forEach((element, index) => {
        blueDots.forEach((key) => {
          if (key.index === index) {
            element.classList.remove("black", "red");
            element.classList.add("white");
            element.querySelectorAll("span").forEach((elem, index) => {
              elem.innerHTML =
                this.state.chromaticFormula.modesOfScalesValues.numbers[
                  key.number - 1
                ];
            });
          }
        });
      });
  };
  showGhostFunction = () => {
    const ghost = document.querySelectorAll(".grey");
    ghost.forEach((x) =>
      this.props.showGhost
        ? x.classList.remove("hide-ghost")
        : x.classList.add("hide-ghost")
    );
  };

  // ghost formula
  mtGhostChange = () => {
    if (!this.props.ghostTonesMT?.modesOfScalesValues?.formulae) {
      return;
    }
    let redDots = [];
    let j = this.props.ghostTonesMT.baseNote;
    for (let i = 0; i < 8; i++) {
      if (i === 0) {
        redDots.push({
          index: j,
          ghost: true,
        });
      } else {
        j = j + 12;
        redDots.push({
          index: j,
          ghost: true,
        });
      }
    }
    // const dotsArray = document.querySelectorAll(".react-piano-music-dots");
    // dotsArray.forEach((element, index) => {
    //   let matchedIndex = redDots.find((x) => x.index === index);
    //   if (matchedIndex) {
    //     element.classList.remove("white");
    //     element.classList.add("grey");
    //     if (!this.props.showGhost) {
    //       element.classList.add("hide-ghost");
    //     }
    //     element.querySelectorAll("span").forEach((elem, index) => {
    //       if (
    //         this.props.ghostTonesMT.modesOfScalesValues.underlinedNumbers?.find(
    //           (x) => x === "1"
    //         )
    //       ) {
    //         // elem.classList.add("single-underline");
    //       }
    //       // elem.innerHTML = "1";
    //     });
    //   }
    // });

    // Red dots placement
    let blueDots = [];
    for (let i of redDots) {
      if (this.props.ghostTonesMT.modesOfScalesValues.formulae) {
        for (let key of this.props.ghostTonesMT.modesOfScalesValues.formulae) {
          let idx = i.index + key - 1;
          if (idx > 95) {
            // Handle wrapping around the index if it exceeds 95
            const wrappedIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            if (idx >= 96 && idx <= 106) {
              const wrappedIdx = wrappedIndexes[idx - 96];
              blueDots.push({
                index: wrappedIdx,
                ghost: true,
              });
            }
          } else {
            if (idx !== i.index) {
              blueDots.push({
                index: idx,
                ghost: true,
              });
            }
          }
        }
      }
    }
    // // redDots.sort();
    // let numbersOnRed;
    // numbersOnRed =
    //   this.props.ghostTonesMT.modesOfScalesValues.numbers.length + 1;
    // let indexInner = 2;
    // for (let i = 0; i < blueDots.length; i++) {
    //   blueDots[i].number = indexInner;
    //   indexInner += 1;
    //   if (indexInner >= numbersOnRed) {
    //     indexInner = 2;
    //   }
    // }
    // // console.log(redDots, blueDots);
    // document
    //   .querySelectorAll(".react-piano-music-dots")
    //   .forEach((element, index) => {
    //     blueDots.forEach((key) => {
    //       if (key.index === index) {
    //         element.classList.remove("black", "red");
    //         element.classList.add("grey");
    //         if (!this.props.showGhost) {
    //           element.classList.add("hide-ghost");
    //         }
    //         element.querySelectorAll("span").forEach((elem, index) => {
    //           if (
    //             this.props.ghostTonesMT.modesOfScalesValues.underlinedNumbers?.find(
    //               (x) =>
    //                 x ===
    //                 this.props.ghostTonesMT.modesOfScalesValues.numbers[
    //                   key.number - 1
    //                 ]
    //             )
    //           ) {
    //             // elem.innerHTML =
    //             //   this.props.tonesMT.modesOfScalesValues.numbers[
    //             //     key.number - 1
    //             //   ];
    //             // elem.classList.add("single-underline");
    //           } else if (
    //             this.props.ghostTonesMT.modesOfScalesValues.doubleUnderlineNumbers?.find(
    //               (x) =>
    //                 x ===
    //                 this.props.ghostTonesMT.modesOfScalesValues.numbers[
    //                   key.number - 1
    //                 ]
    //             )
    //           ) {
    //             // elem.innerHTML =
    //             //   this.props.tonesMT.modesOfScalesValues.numbers[
    //             //     key.number - 1
    //             //   ];
    //             // elem.classList.add("double-underline");
    //           } else {
    //             // elem.innerHTML =
    //             //   this.props.tonesMT.modesOfScalesValues.numbers[
    //             //     key.number - 1
    //             //   ];
    //           }
    //         });
    //       }
    //     });
    //   });
    return [...redDots, ...blueDots].sort((a, b) => a.index - b.index);
  };
  calculateDegree = () => {
    let degreeArray = [
      "1.",
      "b2.",
      "2.",
      "b3.",
      "3.",
      "4.",
      "♯4.",
      "5.",
      "b6.",
      "6.",
      "b7.",
      "7.",
    ];
    let currentDegree = this.props.NOTES[this.props.tonesMT.baseNote]; // Assume this is a string like "F"
    let centerDegree = this.state.centerDegree; // Assume this is a string like "C"

    if (centerDegree === currentDegree) {
      this.setState({ prevDegree: degreeArray[0] });
      return;
    }
    // Find index of centerDegree and currentDegree in the NOTES array
    let centerIndex = this.props.NOTES.indexOf(centerDegree);
    let currentIndex = this.props.NOTES.indexOf(currentDegree);

    // Calculate the distance (forward or wrapping)
    let distance;
    if (currentIndex >= centerIndex) {
      distance = currentIndex - centerIndex;
    } else {
      distance = this.props.NOTES.length - centerIndex + currentIndex;
    }

    // Use the calculated distance to find the prevDegree in degreeArray
    let prevDegree = degreeArray[distance];
    console.log(prevDegree);
    this.setState({ prevDegree });
  };

  mtChange = () => {
    let rhombusIndex;
    let musicTheoryMidiNums = [];
    if (!this.props.tonesMT.modesOfScalesValues.formulae) {
      return;
    }
    if (
      this.state.TONES[this.props.tonesMT.tones] === "Tonal Scales and Modes"
    ) {
      rhombusIndex = this.sevenToneFormula();
    } else {
      this.setState({ sevenToneHeading: "" });
      if (this.props.userSelectedLabels) {
        changeLabels(
          this.props.selectedLabel,
          this.props.setPianoLabels,
          this.props.tonesMT,
          this.props.setBaseNote
        );
      }
    }
    if (this.state.centerLock) {
      // this.setState(
      //   {
      //     centerDegree: this.props.NOTES[this.props.tonesMT.baseNote],
      //   },
      //   () => {
      //     this.calculateDegree();
      //   }
      // );
      this.calculateDegree();
    } 
    else {
      // to sync center basenote with the one currently selected in the formulae when center is unlocked
      if(this.props.tonesMT.baseNote && this.props.baseNote[this.props.tonesMT.baseNote]){
        this.setState({ centerDegree: this.props.baseNote[this.props.tonesMT.baseNote] });
      }
      
    }
    // else {
    //   this.calculateDegree();
    // }

    // chromatic formula call
    this.mtChromatic();
    // ghost formula call
    let ghostArray = this.mtGhostChange();
    let redDots = [];
    let j = this.props.tonesMT.baseNote;
    for (let i = 0; i < 8; i++) {
      if (i === 0) {
        redDots.push({
          index: j,
          ...(rhombusIndex?.find((x) => x.index === this.props.tonesMT.baseNote)
            ? { rhombus: true }
            : {}),
        });
      } else {
        j = j + 12;
        redDots.push({
          index: j,
          ...(rhombusIndex?.find((x) => x.index === j)
            ? { rhombus: true }
            : {}),
        });
      }
    }

    ghostArray = ghostArray?.filter(
      (obj1) => !redDots.some((obj2) => obj2.index === obj1.index)
    );

    const dotsArray = document.querySelectorAll(".react-piano-music-dots");

    dotsArray.forEach((element, index) => {
      element.classList.remove(
        "edit-key-highlight-fade-black",
        "edit-key-highlight-fade-red"
      );
      let matchedIndex = redDots.find((x) => x.index === index);
      if (matchedIndex) {
        if (matchedIndex.rhombus) {
          element.classList.add("rhombus");
        }
        element.classList.remove(
          "single-underline",
          "double-underline",
          "grey",
          "white",
          "hide-ghost",
          "edit-key-highlight-fade-black",
          "edit-key-highlight-fade-red"
        );
        element.classList.add("red");
        element.querySelectorAll("span").forEach((elem, index) => {
          if (
            this.props.tonesMT.modesOfScalesValues.underlinedNumbers?.find(
              (x) => x === "1"
            )
          ) {
            elem.classList.add("single-underline");
          } else if (
            this.props.tonesMT.modesOfScalesValues.doubleUnderlineNumbers?.find(
              (x) => x === "1"
            )
          ) {
            elem.classList.add("double-underline");
          }
          elem.innerHTML = "1";
        });
      }
    });
    // Red dots placement
    let blueDots = [];
    for (let i of redDots) {
      if (this.props.tonesMT.modesOfScalesValues.formulae) {
        for (let key of this.props.tonesMT.modesOfScalesValues.formulae) {
          let idx = i.index + key - 1;
          musicTheoryMidiNums.push(i.index);
          const isRhombus = rhombusIndex?.find((x) => x.index === idx);
          if (idx > 95) {
            // Handle wrapping around the index if it exceeds 95
            const wrappedIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            if (idx >= 96 && idx <= 106) {
              const wrappedIdx = wrappedIndexes[idx - 96];
              blueDots.push({
                index: wrappedIdx,
                ...(rhombusIndex?.find((x) => x.index === wrappedIdx)
                  ? { rhombus: true }
                  : {}),
              });
            }
          } else {
            if (idx !== i.index) {
              blueDots.push({
                index: idx,
                ...(isRhombus ? { rhombus: true } : {}),
              });
            }
          }
        }
      }
    }
    // redDots.sort();
    let numbersOnRed;
    numbersOnRed = this.props.tonesMT.modesOfScalesValues.numbers.length + 1;
    let indexInner = 2;
    for (let i = 0; i < blueDots.length; i++) {
      blueDots[i].number = indexInner;
      indexInner += 1;
      if (indexInner >= numbersOnRed) {
        indexInner = 2;
      }
    }
    ghostArray = ghostArray?.filter(
      (obj1) => !blueDots.some((obj2) => obj2.index === obj1.index)
    );
    if (ghostArray) {
      blueDots = [...blueDots, ...ghostArray].sort((a, b) => a.index - b.index);
    }
    document
      .querySelectorAll(".react-piano-music-dots")
      .forEach((element, index) => {
        blueDots.forEach((key) => {
          if (key.index === index) {
            if (key.ghost) {
              // element.classList.remove("black");
              element.classList.add("grey");
              if (!this.props.showGhost) {
                element.classList.add("hide-ghost");
              }
              // element.querySelector("span").innerHTML =
              //   this.state.chromaticFormula.modesOfScalesValues.numbers[
              //     ((index % 12) - this.props.tonesMT.baseNote + 12) % 12
              //   ];
            } else {
              musicTheoryMidiNums.push(key.index);
              // Remove all classes and add new ones based on `key` properties
              element.classList.remove(
                "single-underline",
                "double-underline",
                "grey",
                "white",
                "hide-ghost"
              );
              element.classList.add("black");
              if (key.rhombus) {
                element.classList.add("rhombus");
              }

              // Check and apply square class if `key.number` is in squareNumbers
              const currentNumber =
                this.props.tonesMT.modesOfScalesValues.numbers[key.number - 1];
              if (
                this.props.tonesMT.modesOfScalesValues.squareNumbers?.includes(
                  currentNumber
                )
              ) {
                element.classList.add("square");
              }

              // Update innerHTML and underline classes based on conditions
              element.querySelectorAll("span").forEach((elem) => {
                elem.innerHTML = currentNumber;

                if (
                  this.props.tonesMT.modesOfScalesValues.underlinedNumbers?.includes(
                    currentNumber
                  )
                ) {
                  elem.classList.add("single-underline");
                } else if (
                  this.props.tonesMT.modesOfScalesValues.doubleUnderlineNumbers?.includes(
                    currentNumber
                  )
                ) {
                  elem.classList.add("double-underline");
                } else {
                  elem.classList.remove("single-underline", "double-underline");
                }
              });
            }
          }
        });
      });
    if (this.state.scaleIntegerKey !== "") {
      document.querySelectorAll(".react-piano-music-dots").forEach((dot) => {
        dot.classList.remove("edit-key-highlight");
        let innerElement = dot.querySelector(".number");
        if (innerElement.innerText.includes(this.state.scaleIntegerKey)) {
          if (this.state.scaleIntegerKey == "1") {
            if (!dot.classList.contains("white")) {
              dot.classList.add("edit-key-highlight-fade-red");
            }
          } else {
            if (!dot.classList.contains("white")) {
              dot.classList.add("edit-key-highlight-fade-black");
            }
          }
        }
      });
      this.setState({ scaleIntegerKey: "" });
    }
    const uniqueArray = [...new Set(musicTheoryMidiNums)];

    // Step 2: Add 21 to each unique value
    const updatedArray = uniqueArray.map((value) => value + 21);
    this.props.setMusicTheoryMidiNums(updatedArray);
  };
  // Start resizing
  handleMouseDown = (e) => {
    e.preventDefault();
    this.setState({
      isResizing: true,
      initialMouseX: e.clientX,
      initialScale: this.state.scale,
    });

    // Add mouse move and mouse up listeners
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  };

  // Handle resizing (scaling)
  handleMouseMove = (e) => {
    if (!this.state.isResizing) return;

    const { initialMouseX, initialScale } = this.state;
    const minScale = 0.5;
    const maxScale = 1.2;

    // Calculate the new scale based on mouse movement
    const deltaX = e.clientX - initialMouseX;
    let newScale = initialScale + deltaX * 0.003; // Adjust the scaling speed as needed
    // Clamp the scale between min and max
    newScale = Math.max(minScale, Math.min(newScale, maxScale));

    this.setState({
      scale: newScale,
    });
  };

  // Stop resizing
  handleMouseUp = () => {
    this.setState({ isResizing: false });
    // Remove mouse move and mouse up listeners
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
  };
  render() {
    const {
      showSettingsModal,
      toggleVocalModal,
      toggleMusicTheoryModal,
      enableMusicTheory,
      modeNames,
      centerSelect,
      centerDegree,
      TONES,
      tones,
      toggleLabelsModal,
      scale,
    } = this.state;
    return (
      <div className="container-wrapper">
        {this.props.bufferLoading && (
          <div>
            <Loader loading={this.props.bufferLoading} />
          </div>
        )}
        <div className="piano-container">
          <div className="row mt-5">
            <div className="">
              <SoundfontProvider
                render={({ isLoading, playNote, stopNote, stopAllNotes }) => (
                  <div>
                    <div className="mt-4 piano-dimensions">
                      {/* <DimensionsProvider>
                        {({ containerWidth }) => (
                          <Piano
                            noteRange={this.state.config.noteRange}
                            keyboardShortcuts={keyboardShortcuts}
                            playNote={playNote}
                            stopNote={stopNote}
                            disabled={isLoading}
                            width={containerWidth}
                          />
                        )}
                      </DimensionsProvider> */}
                      <div className="row">
                        <div className="col text-right position-relative">
                          {this.state.enableMusicTheory &&
                            this.props.tonesMT?.modesOfScalesValues.name && (
                              <div className="center-lock text-center">
                                <span
                                  className="lock-icon"
                                  onClick={this.handleCenterLock}
                                >
                                  {this.state.centerLock ? (
                                    <i className="fa fa-lock"></i>
                                  ) : (
                                    <i className="fa fa-unlock"></i>
                                  )}
                                </span>
                                <div className="d-flex flex-column center-text align-items-center">
                                  <span>Center</span>
                                  <button
                                    ref={this.dropdownRef}
                                    id="baseNote"
                                    className="form-control text-center center-dropdown"
                                    onClick={this.toggleDropdown} // Toggle dropdown on button click
                                  >
                                    {centerDegree || "Select Note"}{" "}
                                  </button>

                                  {centerSelect && (
                                    <div className="center-dropdown-menu show">
                                      {NOTES.map((item, index) => (
                                        <div
                                          key={item}
                                          className="center-dropdown-item"
                                          onClick={() =>
                                            this.handleSelect(item, index)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          {item}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          <a
                            className="btn btn_primary btn-lg mr-2"
                            // onClick={this.toggleUsabilityModal}
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.vocalresults.com/webinar"
                          >
                            How to Use{" "}
                            <i className="fa fa-question-circle-o"></i>
                          </a>
                          <button
                            className="btn btn_primary btn-lg mr-2"
                            onClick={this.toggleSettingsModal}
                          >
                            <i className="fa fa-cogs"></i>
                          </button>
                          <button
                            className="btn btn_primary btn-lg"
                            onClick={this.handleOpenSongWindow}
                          >
                            <i className="fa fa-bars"></i>
                          </button>
                        </div>
                      </div>

                      <div className="font-weight-bold text-center ghost-text">
                        {this.props.tonesMT?.modesOfScalesValues?.name &&
                          this.props.ghostTonesMT?.modesOfScalesValues?.name &&
                          this.props.showGhost && (
                            <span>
                              <span>
                                {NOTES[this.props.ghostTonesMT.baseNote] ===
                                "D♭/C♯"
                                  ? this.props.ghostTonesMT.modesOfScalesValues
                                      .y === 0 ||
                                    this.props.ghostTonesMT.modesOfScalesValues
                                      .y === 1
                                    ? "D♭"
                                    : "C♯"
                                  : NOTES[this.props.ghostTonesMT.baseNote] ===
                                    "A♭/G♯"
                                  ? this.props.ghostTonesMT.modesOfScalesValues
                                      .y === 0 ||
                                    this.props.ghostTonesMT.modesOfScalesValues
                                      .y === 1
                                    ? "A♭"
                                    : "G♯"
                                  : NOTES[this.props.ghostTonesMT.baseNote]}
                              </span>{" "}
                              {this.props.ghostTonesMT.modesOfScalesValues.name}{" "}
                              {
                                this.props.ghostTonesMT.modesOfScalesValues
                                  .degree
                              }{" "}
                              {this.props.ghostTonesMT.modesOfScalesValues
                                .secondDegree || ""}
                            </span>
                          )}
                        {!this.props.showGhost && (
                          <span className="ghost-text"></span>
                        )}
                      </div>

                      {enableMusicTheory &&
                        this.props.tonesMT?.modesOfScalesValues.name && (
                          <div className="mb-4">
                            <div className="font-weight-bold text-center music-theory-text">
                              <span onClick={this.toggleMusicTheoryModalFunc}>
                                <span
                                  style={{
                                    color: "#fff",
                                    textShadow: `
                                      0px 0px 0px #fff,
                                      0px 0px 3px #fff,
                                      0px 0px 15px #fff,
                                      0px 0px 3px #fff
                                    `,
                                  }}
                                >
                                  {
                                    this.props.baseNote[
                                      this.props.tonesMT.baseNote
                                    ]
                                  }
                                </span>
                                {TONES[this.props.tonesMT?.tones] !==
                                  "Octophonic scales" && (
                                  <>
                                    <span
                                      className="mt-0 name"
                                      style={{
                                        color: `${this.props.tonesMT.modesOfScalesValues?.nameColor}`,
                                        textShadow: `
                                            0px 0px 0px ${this.props.tonesMT.modesOfScalesValues?.nameColor},
                                            0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.nameColor},
                                            0px 0px 15px ${this.props.tonesMT.modesOfScalesValues?.nameColor},
                                            0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.nameColor}
                                            `,
                                      }}
                                    >
                                      {` ${this.props.tonesMT.modesOfScalesValues.name}`}
                                    </span>{" "}
                                    <span
                                      className="mt-0 name2"
                                      style={{
                                        color:
                                          this.props.tonesMT.modesOfScalesValues
                                            ?.name2Color,
                                        textShadow: `
                                            0px 0px 0px ${this.props.tonesMT.modesOfScalesValues?.name2Color},
                                            0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.name2Color},
                                            0px 0px 15px ${this.props.tonesMT.modesOfScalesValues?.name2Color},
                                            0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.name2Color}
                                          `,
                                      }}
                                    >
                                      {` ${
                                        this.props.tonesMT.modesOfScalesValues
                                          .name2
                                          ? this.props.tonesMT
                                              .modesOfScalesValues.name2
                                          : ""
                                      }`}
                                    </span>
                                    <span
                                      style={{
                                        color: `${this.props.tonesMT.modesOfScalesValues?.degreeColor}`,
                                        textShadow: `
                                            0px 0px 0px ${this.props.tonesMT.modesOfScalesValues?.degreeColor},
                                            0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.degreeColor},
                                            0px 0px 15px ${this.props.tonesMT.modesOfScalesValues?.degreeColor},
                                            0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.degreeColor}
                                          `,
                                      }}
                                    >
                                      {this.props.tonesMT.modesOfScalesValues
                                        ?.degree || ""}
                                    </span>{" "}
                                    <span
                                      style={{
                                        color: `${this.props.tonesMT.modesOfScalesValues?.secondDegreeColor}`,
                                        textShadow: `
                                                0px 0px 0px ${this.props.tonesMT.modesOfScalesValues?.secondDegreeColor},
                                                0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.secondDegreeColor},
                                                0px 0px 15px ${this.props.tonesMT.modesOfScalesValues?.secondDegreeColor},
                                                0px 0px 3px ${this.props.tonesMT.modesOfScalesValues?.secondDegreeColor}
                                              `,
                                      }}
                                    >
                                      {this.props.tonesMT.modesOfScalesValues
                                        ?.secondDegree || ""}
                                    </span>{" "}
                                    <span
                                      style={{
                                        color: `#fff`,
                                        fontSize: "22px",
                                        textShadow: `
                                          0px 0px 0px #fff,
                                          0px 0px 3px #fff,
                                          0px 0px 15px #fff,
                                          0px 0px 3px #fff,
                                        `,
                                      }}
                                    >
                                      {this.props.tonesMT.modesOfScalesValues
                                        ?.text || ""}
                                    </span>
                                  </>
                                )}
                                {this.props.tonesMT?.modesOfScalesValues.name ==
                                  "Half/whole" && (
                                  <span>
                                    <span
                                      style={{
                                        color: "#ff00b7",
                                        textShadow: `
      0px 0px 0px #ff00b7,
      0px 0px 3px #ff00b7,
      0px 0px 15px #ff00b7,
      0px 0px 3px #ff00b7
    `,
                                      }}
                                    >
                                      {" "}
                                      Ha
                                    </span>
                                    <span
                                      style={{
                                        color: "#1e62ff",
                                        textShadow: `
      0px 0px 0px #1e62ff,
      0px 0px 3px #1e62ff,
      0px 0px 15px #1e62ff,
      0px 0px 3px #1e62ff
    `,
                                      }}
                                    >
                                      lf/
                                    </span>
                                    <span
                                      style={{
                                        color: "#FFFF00",
                                        textShadow: `
      0px 0px 0px #FFFF00,
      0px 0px 3px #FFFF00,
      0px 0px 15px #FFFF00,
      0px 0px 3px #FFFF00
    `,
                                      }}
                                    >
                                      Wh
                                    </span>
                                    <span
                                      style={{
                                        color: "#FF7F00",
                                        textShadow: `
      0px 0px 0px #FF7F00,
      0px 0px 3px #FF7F00,
      0px 0px 15px #FF7F00,
      0px 0px 3px #FF7F00
    `,
                                      }}
                                    >
                                      ole
                                    </span>
                                  </span>
                                )}
                                {this.props.tonesMT?.modesOfScalesValues
                                  .name === "Whole/half" && (
                                  <span>
                                    <span
                                      style={{
                                        color: "#1e62ff",
                                        textShadow: `
      0px 0px 0px #1e62ff,
      0px 0px 3px #1e62ff,
      0px 0px 15px #1e62ff,
      0px 0px 3px #1e62ff
    `,
                                      }}
                                    >
                                      {" "}
                                      Who
                                    </span>
                                    <span
                                      style={{
                                        color: "#00FF00",
                                        textShadow: `
      0px 0px 0px #00FF00,
      0px 0px 3px #00FF00,
      0px 0px 15px #00FF00,
      0px 0px 3px #00FF00
    `,
                                      }}
                                    >
                                      le/
                                    </span>
                                    <span
                                      style={{
                                        color: "#FFFF00",
                                        textShadow: `
      0px 0px 0px #FFFF00,
      0px 0px 3px #FFFF00,
      0px 0px 15px #FFFF00,
      0px 0px 3px #FFFF00
    `,
                                      }}
                                    >
                                      Ha
                                    </span>
                                    <span
                                      style={{
                                        color: "#FF0000",
                                        textShadow: `
      0px 0px 0px #FF0000,
      0px 0px 3px #FF0000,
      0px 0px 15px #FF0000,
      0px 0px 3px #FF0000
    `,
                                      }}
                                    >
                                      lf
                                    </span>
                                  </span>
                                )}
                              </span>
                              <span
                                style={{
                                  color: "#fff",
                                  textShadow: `
0px 0px 0px #fff,
0px 0px 3px #fff,
0px 0px 15px #fff,
0px 0px 3px #fff
`,
                                }}
                              >
                                {this.props.tonesMT.modesOfScalesValues
                                  .chromaticFormula
                                  ? " + Chrom"
                                  : ""}
                              </span>
                            </div>
                            <div
                              className="font-weight-bold text-center base-scale"
                              style={{ minHeight: "1.5em" }}
                            >
                              <span
                                style={{
                                  color: "#fff",
                                }}
                              >
                                {this.state.centerLock
                                  ? this.state.prevDegree
                                  : this.props.tonesMT.modesOfScalesValues
                                      .prevDegree || ""}
                              </span>{" "}
                              <span onClick={this.toggleMusicTheoryModalFunc}>
                                {this.state.sevenToneHeading || ""}
                              </span>
                            </div>
                          </div>
                        )}
                      <Piano
                        noteRange={this.props.config.noteRange}
                        playNote={playNote}
                        stopNote={stopNote}
                        disabled={isLoading}
                        // width={containerWidth}
                      />
                      <div className="row mt-5">
                        <div className="col  text-right">
                          <button
                            className="btn btn_secondary mr-2"
                            onClick={this.movePianoLeft}
                          >
                            <i className="fa fa-arrow-left"></i>
                          </button>
                          <button
                            className="btn btn_secondary"
                            onClick={this.movePianoRight}
                          >
                            <i className="fa fa-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* <div className="row mt-5">
                      <div className="col-lg-8 offset-lg-2">
                        <InstrumentListProvider
                          hostname={soundfontHostname}
                          render={(instrumentList) => (
                            <PianoConfig
                              config={this.state.config}
                              setConfig={(config) => {
                                this.setState({
                                  config: Object.assign(
                                    {},
                                    this.state.config,
                                    config
                                  ),
                                });
                                stopAllNotes();
                              }}
                              instrumentList={
                                instrumentList || [
                                  this.state.config.instrumentName,
                                ]
                              }
                              keyboardShortcuts={keyboardShortcuts}
                            />
                          )}
                        />
                      </div>
                    </div> */}
                  </div>
                )}
              />
              <SongsWindow
                enableMusicTheory={enableMusicTheory}
                setEnableMusicTheory={this.setEnableMusicTheory}
              />
            </div>
          </div>
        </div>

        {this.props.widgetStarted && (
          <Draggable bounds="body">
            <div
              className="draggable-wrapper"
              style={{
                display: "inline-block",
                position: "relative",
                transform: "translate(9px, -4px)",
                scale: "(0.5)",
                zIndex: "2",
              }}
            >
              <div
                className="tuner-container text-center tuner"
                style={{
                  transform: `scale(${scale})`,
                  transformOrigin: "top left", // Optional to keep the scaling consistent
                  display: "inline-block",

                  position: "relative",
                }}
              >
                <Tuner tones={tones} />
                {/* Resizable handle */}
                <div
                  onMouseDown={this.handleMouseDown}
                  style={{
                    width: "15px",
                    height: "15px",
                    backgroundColor: "gray",
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    cursor: "se-resize",
                  }}
                ></div>
              </div>
            </div>
          </Draggable>
        )}
        {showSettingsModal && (
          <SettingsPopup
            show={showSettingsModal}
            toggleModal={this.toggleSettingsModal}
            toggleVocalModalFunc={this.toggleVocalModalFunc}
            toggleMusicTheoryModalFunc={this.toggleMusicTheoryModalFunc}
            toggleLabelsModalFunc={this.toggleLabelsModalFunc}
            mtChange={this.mtChange}
          />
        )}
        {toggleVocalModal && (
          <PopupTones
            show={toggleVocalModal}
            toggleModal={this.toggleVocalModalFunc}
          />
        )}
        {toggleMusicTheoryModal && (
          <PopupMusicTheory
            show={toggleMusicTheoryModal}
            toggleModal={this.toggleMusicTheoryModalFunc}
            setMusicTheoryOnPiano={this.setMusicTheoryOnPiano}
            enableMusicTheory={enableMusicTheory}
            setEnableMusicTheory={this.setEnableMusicTheory}
          />
        )}
        {toggleLabelsModal && (
          <LabelsModal
            show={toggleLabelsModal}
            toggleModal={this.toggleLabelsModalFunc}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    musicTheoryFormula: state.musicTheoryFormula,
    voiceDetect: state.voiceDetect,
    widgetStarted: state.widgetStarted,
    tonesMT: state.tonesMT,
    ghostTonesMT: state.ghostTonesMT,
    showGhost: state.showGhost,
    allNotes: state.allNotes,
    NOTES: state.notes,
    openNewSongModal: state.openNewSongModal,
    bufferLoading: state.bufferLoading,
    autoLabel: state.autoLabel,
    currentSongIndex: state.currentSongIndex,
    songsArray: state.songsArray,
    currentSongName: state.currentSongName,
    scaleEditing: state.scaleEditing,
    openNewSectionModal: state.openNewSectionModal,
    baseNote: state.baseNote,
    currentSectionName: state.currentSectionName,
    userSelectedLabels: state.userSelectedLabels,
    selectedLabel: state.selectedLabel,
    defaultMt: state.defaultMt,
  };
};

const mapDispatchToProps = {
  setMusicThoeryFormula,
  setTonesMT,
  setPianoLabels,
  setSongsArray,
  setGhostTonesMT,
  setShowGhost,
  setScaleEditing,
  setNewSectionModal,
  setBaseNote,
  setCurrentSongIndex,
  setCurrentSectionName,
  setMusicTheoryMidiNums,
  setDefaultMt,
  setBufferLoading,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbarWrapper(HomePiano));

